import { useCallback, useState } from 'react';
import { CustomerFormValues, EmbedPageState, INITIAL_EMBED_PAGE_STATE } from './embedPageState';

export type UpdateEmbedPageState = (patch: Partial<EmbedPageState>) => void;

export type UpdateCustomerValues = (patch: Partial<CustomerFormValues>) => void;

export interface EmbedPageStateHandle {
    state: EmbedPageState;
    updateState: UpdateEmbedPageState;
    updateCustomer: UpdateCustomerValues;
}

export const useEmbedPageState = (): EmbedPageStateHandle => {
    const [state, setState] = useState<EmbedPageState>(INITIAL_EMBED_PAGE_STATE);

    const updateState = useCallback<UpdateEmbedPageState>(
        (patch) => setState((previous) => ({ ...previous, ...patch })),
        []
    );

    const updateCustomer = useCallback<UpdateCustomerValues>(
        (patch) =>
            setState((previous) => ({
                ...previous,
                customer: { ...previous.customer, ...patch },
            })),
        []
    );

    return { state, updateState, updateCustomer };
};
